module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAHCAYAAADebrddAAAAdklEQVQYlYXKMQrCQBRF0RPJDgVhSBdLGysrN2BlaZMdBLIBKysbVyFWugIFUT4mEAYkt5l5/FOklBosTXeYYYXLBD1jHfiJOR5/4B0LvAJHV1R4ZzB2wFuMAUdHbDO8wWkYYxzt0PX/FvvxsczwBzWK/o39C1+VLhWjYitXEwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/lang/downICON.png
// module id = 679
// module chunks = 28